import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/firestore'

export const login = ({dispatch}, {token}) => {
  return firebase.auth().signInWithCustomToken(token)
    .then(token => {
      console.log('@actions.js/loged in with custom token: ', token)
      return dispatch('getUserData', {id: token.user.uid})
    })
    .catch(err => {
      // TODO(garcianavalon) show error message to user
      console.error(err)
    })
}

export const getUserData = ({commit}, {id}) => {
  commit('START_LOADING')
  return firebase.firestore().collection('users').doc(id).get()
    .then(doc => {
      return Object.assign({id}, doc.data())
    })
    .then(user => {
      console.log('@actions.js/got user extra data: ', user)
      commit('USER_LOGGED_IN', user)
      commit('STOP_LOADING')
    })
    .catch(err => {
      // TODO(garcianavalon) show error message to user
      console.error(err)
    })
}

export const logout = ({commit}) => {
  commit('START_LOADING')
  return firebase.auth().signOut()
    .then(() => {
      console.log('logged out')
      commit('USER_LOGGED_IN', null)
      commit('STOP_LOADING')
    })
    .catch(err => {
      // TODO(garcianavalon) show error message to user
      console.error(err)
    })
}

export const formResponsesData = ({ commit }, {week}) => {
  commit('START_LOADING')
  return firebase.firestore()
    .collection('traffic_light')
    .where('week', '==', String(week))
    .get()
    .then((snapshots) => {
      const results = []
      snapshots.forEach((doc) => {
        results.push(doc.data())
      })

      commit('FORM_RESPONSES_DATA', results)
      commit('STOP_LOADING')
    })
    .catch((err) => {
      console.error(err)
    })
}

export const getAllUsers = ({ commit }) => {
  commit('START_LOADING')
  return firebase.firestore()
    .collection('users')
    .get()
    .then((snapshots) => {
      const results = []
      snapshots.forEach((doc) => {
        results.push(Object.assign({userId: doc.id}, doc.data()))
      })
      commit('ALL_USERS_DATA', results)
      commit('STOP_LOADING')
    })
    .catch((err) => console.error(err))
}



// WEBPACK FOOTER //
// ./src/store/actions.js